
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqQl0FHezYJyR6qS4GclZhn7e5219pY4plzwAJBYPnxMIMeta } from "/codebuild/output/src2359193022/src/src/pages/faq.vue?macro=true";
import { default as menuuC7MhbK_Q6gLZO9Q_45Guc04dHSs4ZSDaYCmhmj1UrDY0Meta } from "/codebuild/output/src2359193022/src/src/pages/menu.vue?macro=true";
import { default as indexKzGn4E887vI7fURHqreCPTX78EPXrYKYM5oHxFlAwUQMeta } from "/codebuild/output/src2359193022/src/src/pages/index.vue?macro=true";
import { default as contactEf7P92iVbHz4o5pTI_69l9sAassf6Xsj_45ynM1_45a0kbwMeta } from "/codebuild/output/src2359193022/src/src/pages/contact.vue?macro=true";
import { default as tutorialPY5MKB503RWnj8rMewNEVmpUDMZ6mIE0aEnrQEGspN8Meta } from "/codebuild/output/src2359193022/src/src/pages/tutorial.vue?macro=true";
import { default as agreementYC3UBAhfhYx4ibdL2IDNaHAySRBhZ1dzEOu5tpQkDl8Meta } from "/codebuild/output/src2359193022/src/src/pages/agreement.vue?macro=true";
import { default as about_45passdqUj7LaCYv9PspPZErWvITZ2W6r8v3w9BJtnrZAab_EMeta } from "/codebuild/output/src2359193022/src/src/pages/about-pass.vue?macro=true";
import { default as indexOsxakDBicAtdPSXK5XG4vsyO1rgvgSPX9WKr5AqjCmQMeta } from "/codebuild/output/src2359193022/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93EVcowFxFueaC0PKVvJzJ9DQL2StHG1j07pZGfcpe5CYMeta } from "/codebuild/output/src2359193022/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancewgaz0W8TYQwnCzkl22wd_45ZHLl5SG7FxoAyDytuzDPukMeta } from "/codebuild/output/src2359193022/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_931QODxzmu6RPzqn4YAVGH5a1HrTz1yv6Ng8qC0yx765cMeta } from "/codebuild/output/src2359193022/src/src/pages/notice/[id].vue?macro=true";
import { default as indexsvCRAHkSGbGoPFBImBQ_45TKK2XVuQ20uELRyo6oatz_45oMeta } from "/codebuild/output/src2359193022/src/src/pages/coupon/index.vue?macro=true";
import { default as indexMsCpkI2AABCsSb_6WFDs_qIHfUaJDuEEDMQwGHkn4wMMeta } from "/codebuild/output/src2359193022/src/src/pages/mypage/index.vue?macro=true";
import { default as indexJYUy65t78_4533wLVywEVd_2el_45bsn9UwrJO_45tvd8jK1sMeta } from "/codebuild/output/src2359193022/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93XSn2cOi2czD5RpF89IBvXDwNpKIrvIVwjNZ_z03JBcoMeta } from "/codebuild/output/src2359193022/src/src/pages/parking/[id].vue?macro=true";
import { default as index_45wrPiCRYR4F243pOFkzTcN1knBTpQ6Zr34n_45e_45vPVIUMeta } from "/codebuild/output/src2359193022/src/src/pages/history/index.vue?macro=true";
import { default as indexvacSGsLVFfOopBpbIe9Yx07yGRq9whpKWRUO_qV0TG0Meta } from "/codebuild/output/src2359193022/src/src/pages/monthly/index.vue?macro=true";
import { default as indexyT_45K6cttJgWBRmAo9ejJNapwChsXnSmi0Ijeve4V360Meta } from "/codebuild/output/src2359193022/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexUu6rR_45_HeBIzqGvuzxoIqbjGPvjNsyzYzZjJClXplqwMeta } from "/codebuild/output/src2359193022/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviyEIw4KkajOW_45mKT64cI51cMWpBuORkrKP4mptN4rPtEMeta } from "/codebuild/output/src2359193022/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edituGkKJ7NZZH4baKJy6RUSVi_455sE7s3ovlNRp1b1_45c7mEMeta } from "/codebuild/output/src2359193022/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementlQEbdsldhwB7deOLp7KcnhPLrhjUdp5UoueeOOZPCO8Meta } from "/codebuild/output/src2359193022/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexGW_oeAnCLOm1gJCs4QBqvYRNBdrKaGRsEa_455kPfOveQMeta } from "/codebuild/output/src2359193022/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453donZonm3A8c_Xgx8XBibqxcEg1AYUdP1LRfgOvhldnqMMeta } from "/codebuild/output/src2359193022/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmEnkY4vcuqjvY8ujiKvHCIwf_45VW6MXx7BJHjvMZ_45KpJ4Meta } from "/codebuild/output/src2359193022/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexpLcUnB79pV0CZFvjB37ZTW0ZCQmqYEdB_45ISehymDzdYMeta } from "/codebuild/output/src2359193022/src/src/pages/card/create/index.vue?macro=true";
import { default as indexu7lkty5wKU58O1acEci_45t11pft7V6aVkpLmwwH4cSMIMeta } from "/codebuild/output/src2359193022/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmb7Ju1qotuK3sKbabsPHZp0skkJMC21_45vNBfeu7X7VIwMeta } from "/codebuild/output/src2359193022/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmlTJiZlf7nBKdk7Q795N325oW7Lzt3Y7qXRg12mfidUsMeta } from "/codebuild/output/src2359193022/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeapLZ8rv0fXTToFRJuUVB3CLNL0KSnVSbKV9f5kZpO8oMeta } from "/codebuild/output/src2359193022/src/src/pages/membership/complete.vue?macro=true";
import { default as register4bmhlZGJTHoZtU8q9x1brJbE7HYSxTg6MWMRnWyWAaYMeta } from "/codebuild/output/src2359193022/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93B7879DDlZuLLenq_45KYVM42V3AlYgdmTiEU8B8lHgbsYMeta } from "/codebuild/output/src2359193022/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmAPqElzOSWHOLMbzNwa0JQIT3uew6DIuIyYJmemDne6wMeta } from "/codebuild/output/src2359193022/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93qbm74eNsHkVGZz5mprLIgOWx3a4saOqu0o9S6pd_45v2kMeta } from "/codebuild/output/src2359193022/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexPRl87OCXaIaeb90j3eBrROHJlcvFQeQdiHMti0Jj7IEMeta } from "/codebuild/output/src2359193022/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code_45q4TVVlpXKK5_AU1r9m_Ua4tAmE5kpByvtp2Y6b2r58Meta } from "/codebuild/output/src2359193022/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeVmE4fMszcXzATY82SkVnItSz0oCzZzIvc4b_BwcALEMMeta } from "/codebuild/output/src2359193022/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completewvkzrQpjiGdAEvQLkOh_45e9r8LD2RGZUWZQct_450iCG3EMeta } from "/codebuild/output/src2359193022/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerFuwThwhkzjZZ085sX6idxQwHwnEuqAvjivA_45Pg4JFbUMeta } from "/codebuild/output/src2359193022/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete5jfn_45hItqX7lQLlcO6LOgK0O4a6N1RVDFxx10P_yccwMeta } from "/codebuild/output/src2359193022/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexZVQoFs6JSfGQ0RqkGSeL9VXFuVOqnX7fp4aGo_gKOc4Meta } from "/codebuild/output/src2359193022/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmKCL_3YOyNv6dnsoX0loFDhNsZLWJlro7l3ZRtGoHB0UMeta } from "/codebuild/output/src2359193022/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete8IwNZ0qnY8xKxuRE0aKNSLKzLggq51zaMkKmh2AbWo0Meta } from "/codebuild/output/src2359193022/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexsqsgitOr8LKMmnIOJhCCqfVnGE6RTnYMtvXBePKsq3EMeta } from "/codebuild/output/src2359193022/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93EtZ0Eb411Prwarli1FzvyOPpMh5nZLgw0n6xiKB1zr8Meta } from "/codebuild/output/src2359193022/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeqTH2COff1v3oUCeA7DP_YWMue2KZ5H850JuW8w5E118Meta } from "/codebuild/output/src2359193022/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasSYFmBZtJwBgfNB_hu1m_spJR4n1RrDtzThc098Pq2GMMeta } from "/codebuild/output/src2359193022/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample9wp9k9EvdCCH2XCFeh_WCbay_TYGSHi6resdrWcl11gMeta } from "/codebuild/output/src2359193022/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emaillpJFujgd0XllQCIvVy6RduLtEIWkKuQvSMV_45DMQ7VgkMeta } from "/codebuild/output/src2359193022/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmDFgL0EcQvGmgJPe38uQ1_45Y9NzSuT7D2DByUG51VztSIMeta } from "/codebuild/output/src2359193022/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent0YeLNCDl1YYNZAf7AJd7IV57X6z8eKEPF8KazpBZBQ0Meta } from "/codebuild/output/src2359193022/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmDvOXI4kgZ97krZeftF9LoZpDyAeNV5tw9kvU2rJZ7o4Meta } from "/codebuild/output/src2359193022/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateS348SYlFqnDJRH_451LHlPRmXqxvEH0DzHdjeCScFCNxkMeta } from "/codebuild/output/src2359193022/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeeHxMtkpNAEcA5hmljvBTOM60baUr2sMCEtW1tgCJvDYMeta } from "/codebuild/output/src2359193022/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code312qe33X2kng01QSQgl3OhLN6nF40gBNOl2GKsoWbKgMeta } from "/codebuild/output/src2359193022/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordfKKZD3nWqVW6lZWnL_45d_A0kpHbIFB0JG61nEhwtkQ5AMeta } from "/codebuild/output/src2359193022/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasNkG6GxGBhcZZckH10HzvGb4B4L1W7IWQwqw8fjcmykEMeta } from "/codebuild/output/src2359193022/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register6nJ6QO9_45GFY8QaX5U7EKVtFE2jNcAyACcwvbboXi46oMeta } from "/codebuild/output/src2359193022/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code8Rg_nqhJnKPK1AnmZQpppWWelBDMgwTXD_45L60Nz52foMeta } from "/codebuild/output/src2359193022/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index4_45XQ8imxYVLmIzExdfsyz8pwbKMTSbC9rzB2vLyLa6MMeta } from "/codebuild/output/src2359193022/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexmhp2pKYXiqT8f5GQBDAdlk_458WU2FDpzqMtCQgdT6Z5EMeta } from "/codebuild/output/src2359193022/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexJR0xHBMZQXRPXCykzXba3abAprpGNhG72QvHV3NqhxsMeta } from "/codebuild/output/src2359193022/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexqGIGt_K7zw0R8P1fSY4VHr5z3vbVfY0slgOAjmUHgbEMeta } from "/codebuild/output/src2359193022/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateVd6onNJQaakheSGZvOtn0gcpTeAihAtO9UFHPWuue3EMeta } from "/codebuild/output/src2359193022/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completetRkl5lvEE6RHz776mJkbS4XKgNskL5IDJOSxZdNnupEMeta } from "/codebuild/output/src2359193022/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirme3H8QQu_iKHnl0BdRhQ33P_45ouFdshBQBuekzB2M9ov8Meta } from "/codebuild/output/src2359193022/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexiv2RzyGjmRxKsK9ksVqnuY6a6AjfRfn4cJw4fxWD7JIMeta } from "/codebuild/output/src2359193022/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeqyMZtXYLSg9WUfO6UUMfAnoNqJKE3bqimvgyf2QAPtMMeta } from "/codebuild/output/src2359193022/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update5Ij5XqoHc_mwljdlMulX2DYaTA9ka3unP8bnmQzrXc8Meta } from "/codebuild/output/src2359193022/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexydYyi8VBbF6CJegDbo20Gxe_B_45KQpneWpSJtMSkhjYkMeta } from "/codebuild/output/src2359193022/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexYc3PrZPayvWEjyCfJ3TnPjW_45j1D4NJoVvDKuvT6IZkgMeta } from "/codebuild/output/src2359193022/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeGr_RSXDfOa1AjkiioPxdKTTOgGKpTKoGiL7YXanr_45A8Meta } from "/codebuild/output/src2359193022/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexr9QXYuYpW_J9_3zBfHJgZrTJ4cmTw2NrVxb8WCDOkTgMeta } from "/codebuild/output/src2359193022/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeqGBqq_jhhZ3p0lu8KHhOyj3wvaxyJL2k3PCnCqCRVt8Meta } from "/codebuild/output/src2359193022/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexTvqzGyXAMOCQRB8rBoIfK8DqZBOiTsFkYSMRD7U61WYMeta } from "/codebuild/output/src2359193022/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexd_Sj_VGN1prsyOlv1utyR2tfQaVBlgYiom4Can3SeFgMeta } from "/codebuild/output/src2359193022/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexi749xfkqwRNoIEMotfawqvq1VqYHd__452x9G4ypgScmoMeta } from "/codebuild/output/src2359193022/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateZhYp0h8F9jkk9qZdxjUS7Le4VfGTjPVAmL2QXZSLaccMeta } from "/codebuild/output/src2359193022/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmhzcUBCt56g2mILtE51pCjiuStUFfQdvrOkKpasLLDl4Meta } from "/codebuild/output/src2359193022/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuuC7MhbK_Q6gLZO9Q_45Guc04dHSs4ZSDaYCmhmj1UrDY0Meta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexKzGn4E887vI7fURHqreCPTX78EPXrYKYM5oHxFlAwUQMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src2359193022/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexsvCRAHkSGbGoPFBImBQ_45TKK2XVuQ20uELRyo6oatz_45oMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2359193022/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index_45wrPiCRYR4F243pOFkzTcN1knBTpQ6Zr34n_45e_45vPVIUMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2359193022/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexyT_45K6cttJgWBRmAo9ejJNapwChsXnSmi0Ijeve4V360Meta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexUu6rR_45_HeBIzqGvuzxoIqbjGPvjNsyzYzZjJClXplqwMeta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexpLcUnB79pV0CZFvjB37ZTW0ZCQmqYEdB_45ISehymDzdYMeta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmb7Ju1qotuK3sKbabsPHZp0skkJMC21_45vNBfeu7X7VIwMeta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmlTJiZlf7nBKdk7Q795N325oW7Lzt3Y7qXRg12mfidUsMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2359193022/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeapLZ8rv0fXTToFRJuUVB3CLNL0KSnVSbKV9f5kZpO8oMeta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register4bmhlZGJTHoZtU8q9x1brJbE7HYSxTg6MWMRnWyWAaYMeta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmAPqElzOSWHOLMbzNwa0JQIT3uew6DIuIyYJmemDne6wMeta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code_45q4TVVlpXKK5_AU1r9m_Ua4tAmE5kpByvtp2Y6b2r58Meta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeVmE4fMszcXzATY82SkVnItSz0oCzZzIvc4b_BwcALEMMeta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completewvkzrQpjiGdAEvQLkOh_45e9r8LD2RGZUWZQct_450iCG3EMeta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerFuwThwhkzjZZ085sX6idxQwHwnEuqAvjivA_45Pg4JFbUMeta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmKCL_3YOyNv6dnsoX0loFDhNsZLWJlro7l3ZRtGoHB0UMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete8IwNZ0qnY8xKxuRE0aKNSLKzLggq51zaMkKmh2AbWo0Meta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexsqsgitOr8LKMmnIOJhCCqfVnGE6RTnYMtvXBePKsq3EMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeqTH2COff1v3oUCeA7DP_YWMue2KZ5H850JuW8w5E118Meta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample9wp9k9EvdCCH2XCFeh_WCbay_TYGSHi6resdrWcl11gMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emaillpJFujgd0XllQCIvVy6RduLtEIWkKuQvSMV_45DMQ7VgkMeta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmDFgL0EcQvGmgJPe38uQ1_45Y9NzSuT7D2DByUG51VztSIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent0YeLNCDl1YYNZAf7AJd7IV57X6z8eKEPF8KazpBZBQ0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmDvOXI4kgZ97krZeftF9LoZpDyAeNV5tw9kvU2rJZ7o4Meta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeeHxMtkpNAEcA5hmljvBTOM60baUr2sMCEtW1tgCJvDYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code312qe33X2kng01QSQgl3OhLN6nF40gBNOl2GKsoWbKgMeta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordfKKZD3nWqVW6lZWnL_45d_A0kpHbIFB0JG61nEhwtkQ5AMeta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register6nJ6QO9_45GFY8QaX5U7EKVtFE2jNcAyACcwvbboXi46oMeta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code8Rg_nqhJnKPK1AnmZQpppWWelBDMgwTXD_45L60Nz52foMeta || {},
    component: () => import("/codebuild/output/src2359193022/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2359193022/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]